import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { setRedirectPath } from 'utils/redirect'
import { useLocation } from 'react-router-dom'
import { useReduxSelector } from 'store'
import { useEffect } from 'react'

const useRedirectPath = (
  protectedPath: string
) => {
  const { pathname } = useLocation()
  const isLoggedIn = useReduxSelector(selectIsLoggedIn)
  const isLoading = useReduxSelector(selectIsLoading)

  useEffect(() => {
    if (protectedPath && !isLoading && !isLoggedIn) {
      setRedirectPath(pathname)
    }
  }, [protectedPath, isLoggedIn, isLoading, pathname])
}

export default useRedirectPath